import React from 'react';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { useIntl } from 'react-intl';

import { Subtitle1 } from '../Typography';

export interface ListItemSubtitleTextProps {
  text: string;
  classsName?: string;
}

const ListItemSubtitleText: React.FC<ListItemSubtitleTextProps> = ({
  text,
  classsName,
}) => {
  const intl = useIntl();

  const listItemSubtitleText = intl.formatMessage({
    id: text,
  });
  return (
    <Markdown
      components={{
        p: ({ node, children, ...props }) => (
          <Subtitle1 className={classsName} {...props}>
            {children}
          </Subtitle1>
        ),
      }}
      rehypePlugins={[rehypeRaw as any]}
    >
      {listItemSubtitleText}
    </Markdown>
  );
};

export default ListItemSubtitleText;
